<div class="max-w-5xl mx-auto">
  <div class="page-container">
    <div class="relative page-edge-cut page-edge-cut-white mt-9 sm:mt-0">
      <div class="form-card">
        <h1 class="section-heading">{{ "REGISTER.TITLE" | translate }}</h1>

        <form
          [formGroup]="form"
          (ngSubmit)="submit()"
          class="max-w-3xl mt-8 sm:mt-6"
        >
          <div class="field-control">
            <app-boolean
              [label]="'REGISTER.RESIDENCY_LABEL' | translate"
              [control]="form.get('residencyStatus')!"
              [options]="residencyOptions"
              [labelKey]="'title'"
              [descriptionKey]="'description'"
              [stacked]="true"
              [optionWrapperClass]="'border-blue card-edge-cut relative mb-4'"
              [valueKey]="'value'"
              [translateOptions]="true"
            ></app-boolean>
          </div>

          @if (form.get("residencyStatus")?.value === "resident") {
            <div class="field-control">
              <button
                type="button"
                class="w-full md:w-1/2 bg-black"
                [disabled]="uaePassSubmitting"
                (focus)="onUaePassFocus()"
                (blur)="onUaePassBlur()"
                (pointerdown)="onUaePassPress(true)"
                (pointerup)="onUaePassPress(false)"
                (pointerleave)="onUaePassPress(false)"
                (keydown)="onUaePassKey(true, $event)"
                (keyup)="onUaePassKey(false, $event)"
                (click)="loginWithUaePass()"
              >
                <img
                  [src]="uaePassImage"
                  [alt]="'LOGIN_UAE_PASS' | translate"
                  class="block w-full h-auto max-h-[50px] object-contain bg-black"
                />
              </button>
            </div>
          }

          <!-- @if (form.get("residencyStatus")?.value === "resident") {
            <div class="field-control">
              <app-text-field
                [control]="form.get('emiratesId')!"
                [label]="'OWNER_FORM.EMIRATES_ID' | translate"
                [validationMessages]="{
                  emiratesId: 'VALIDATION_MSG.VALID_EMIRATES_ID' | translate,
                }"
              />
            </div>
            <div class="field-control">
              <div class="field-control">
                <app-date
                  [control]="form.get('emiratesDob')"
                  [label]="'OWNER_FORM.DOB' | translate"
                  [allowedDate]="'past'"
                />
              </div>
            </div>
            <div class="buttons-group mb-8">
              <app-button
                [type]="'button'"
                [label]="'BUTTONS.CHECK_DETAIL' | translate"
                classesName="card-edge-cut-white btn-edge-cut"
                (onBtnClick)="getDetailByEmirateId()"
              />
            </div>
            @if (loadingEmirateInfo) {
              <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
            }
            @if (detailNotFound) {
              <div class="mb-2">
                <app-validation-message
                  [content]="{
                    title: 'ALERT.NO_RESULTS_TITLE' | translate,
                    message: 'ALERT.NO_RESULTS_DESC' | translate,
                  }"
                  type="error"
                />
              </div>
            }
          } -->

          @if (form.get("residencyStatus")?.value !== "resident") {
            @if (form.get("residencyStatus")?.value === "non-resident") {
              <div class="field-control">
                <app-text-field
                  [control]="form.get('passportNumber')!"
                  [label]="'OWNER_FORM.PASSPORT_NO' | translate"
                />
              </div>
              <div class="field-control">
                <div class="field-control">
                  <app-date
                    [allowedDate]="'future'"
                    [control]="form.get('passportExpiry')"
                    [label]="'OWNER_FORM.PASSPORT_EXPIRY' | translate"
                  />
                </div>
              </div>
            }

            @if (
              detailFound && form.get("residencyStatus")?.value === "resident"
            ) {
              <div class="mb-8 space-y-4">
                <table class="w-full text-sm text-dc-navy">
                  <tbody>
                    <tr class="border-b">
                      <td class="py-2 font-medium min-w-2xs">
                        {{ "OWNER_FORM.NAME_EN" | translate }}
                      </td>
                      <td class="py-2">
                        {{ form.get("nameEn")?.value }}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="py-2 font-medium min-w-2xs">
                        {{ "OWNER_FORM.NAME_AR" | translate }}
                      </td>
                      <td class="py-2">
                        {{ form.get("nameAr")?.value }}
                      </td>
                    </tr>
                    <tr class="border-b">
                      <td class="py-2 font-medium">
                        {{ "OWNER_FORM.NATIONALITY" | translate }}
                      </td>
                      <td class="py-2">
                        {{ form.get("nationality")?.value }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            }
            <div class="field-control">
              <app-text-field
                [control]="form.get('nameEn')!"
                [label]="'OWNER_FORM.NAME_EN' | translate"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [control]="form.get('nameAr')!"
                [label]="'OWNER_FORM.NAME_AR' | translate"
              />
            </div>
            <div class="field-control">
              <app-option-field
                [control]="form.get('nationality')!"
                [label]="'OWNER_FORM.NATIONALITY' | translate"
                [country]="true"
                [loading]="loadingCountry"
                [options]="countryList"
                [valueKey]="'Name'"
              />
            </div>

            <div class="field-control">
              <app-boolean
                [label]="'REGISTER.BENEFITS_LABEL' | translate"
                [control]="form.get('benefit')!"
                [options]="benefitOptions"
                [labelKey]="'title'"
                [descriptionKey]="'description'"
                [stacked]="true"
                [optionWrapperClass]="'border-blue card-edge-cut relative mb-4'"
                [valueKey]="'value'"
                [translateOptions]="true"
              ></app-boolean>
            </div>
            @if (isBusinessBenefitSelected) {
              <div class="field-control">
                <app-boolean
                  [label]="'REGISTER.BUSINESS_LABEL' | translate"
                  [control]="form.get('businessLocation')!"
                  [options]="businessLocationOptions"
                  [labelKey]="'label'"
                  [valueKey]="'value'"
                  [translateOptions]="true"
                ></app-boolean>
              </div>
              @if (isBusinessDubaiBased) {
                <div class="field-control">
                  <app-option-field
                    [control]="form.get('issuingAuthority')!"
                    [label]="'REGISTER.ISSUING_AUTHORITY' | translate"
                    [lovType]="LookupKey.DC_LIC_AUTH"
                  />
                </div>

                <div class="field-control">
                  <app-option-field
                    [label]="'REGISTER.FIND_YOUR_BUSINESS_LABEL' | translate"
                    [control]="form.get('companySearch')!"
                    [options]="members"
                    [loading]="loadingMember"
                    [showMemberFilter]="true"
                    [memberSearchByOptions]="companySearchByOptions"
                    [placeholder]="''"
                    [allowManualEntry]="false"
                    [manualEntryLabel]="'COMPANY_NAME'"
                    (search)="handleCompanySearch($event)"
                  ></app-option-field>
                </div>
              }
              @if (!isBusinessDubaiBased) {
                <div class="field-control">
                  <app-text-field
                    [label]="'REGISTER.COMPANY_NAME_LABEL' | translate"
                    [control]="form.get('companySearch')!"
                  ></app-text-field>
                </div>
              }
              <div class="field-control">
                <h1 class="section-heading">
                  {{ "ADD_BUSINESS.ROLE_TITLE" | translate }}
                </h1>
                <app-checkbox
                  [control]="form.get('roles')!"
                  [options]="roleOptionsForSelection"
                  [optionWrapperClass]="'border-blue card-edge-cut relative mb-4'"
                  [translateOptions]="true"
                  (onSelectionChange)="onRoleSelectionChange($event)"
                />
                @if (roleTouched && !hasRoleSelected()) {
                  <div class="fields-error-container">
                    {{ "VALIDATION_MSG.SELECT_ROLE" | translate }}
                  </div>
                }
              </div>
            }

            @if (shouldShowDocumentSection) {
              <div class="field-control">
                <h1 class="section-heading">
                  {{ "DOCUMENTS.TITLE" | translate }}
                </h1>
                @if (loadingDocumentFolder) {
                  <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
                }
                @if (srFolder && !loadingDocumentFolder) {
                  @for (dt of visibleDocumentTypes; track $index) {
                    <div class="field-control">
                      <app-file
                        #fileCmp
                        [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                        [documentType]="dt.nameEn"
                        (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                        [folder]="srFolder"
                        [documentServiceType]="documentServiceType.UM_NU"
                      ></app-file>
                    </div>
                  }
                }
              </div>
            }

            <div class="field-control">
              <h1 class="section-heading">
                {{ "ADD_BUSINESS.CONTACT_TITLE" | translate }}
              </h1>
              <div class="field-control">
                <app-text-field
                  [label]="'EMAIL' | translate"
                  [control]="form.get('email')!"
                  [maxlength]="120"
                ></app-text-field>
              </div>
              <div class="field-control">
                <app-mobile-number
                  [label]="'PHONE_NUMBER' | translate"
                  [control]="form.get('phone')!"
                  [countryCodeControl]="form.get('countryCode')!"
                  [validationMessages]="{
                    mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                    uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate,
                  }"
                ></app-mobile-number>
              </div>
              <div class="field-control">
                <h1 class="section-heading">
                  {{ "REGISTER.LOGIN_DETAILS" | translate }}
                </h1>
                <div class="field-control">
                  <app-text-field
                    [label]="'LOGIN_USERNAME' | translate"
                    [control]="form.get('username')!"
                  ></app-text-field>
                </div>
                <div class="field-control">
                  <app-text-field
                    [label]="'REGISTER.PASSWORD_LABEL' | translate"
                    [control]="form.get('password')!"
                    [type]="'password'"
                    [otherInfo]="'VALIDATION_MSG.PASSWORD_RULES' | translate"
                    [showPasswordToggle]="true"
                  ></app-text-field>
                </div>
                <div class="field-control">
                  <app-text-field
                    [label]="'REGISTER.CONFIRM_PASSWORD_LABEL' | translate"
                    [control]="form.get('confirmPassword')!"
                    [type]="'password'"
                    [showPasswordToggle]="true"
                  ></app-text-field>
                </div>
              </div>
            </div>

            <div class="field-control">
              <div class="flex items-start gap-3 text-dc-navy">
                <input
                  id="termsAccepted"
                  type="checkbox"
                  formControlName="termsAccepted"
                  class="mt-1 h-6 w-6 border-dc-navy accent-dc-navy rounded-none shrink-0"
                />
                <label
                  for="termsAccepted"
                  class="text-base leading-snug md:text-base"
                >
                  {{ "REGISTER.TERMS_ACKNOWLEDGE_PREFIX" | translate }}
                  <button
                    type="button"
                    class="underline underline-offset-4 cursor-pointer"
                    (click)="openMembershipDisclaimer($event)"
                  >
                    {{ "REGISTER.TERMS_AND_CONDITIONS" | translate }}
                  </button>
                  {{ "REGISTER.TERMS_ACKNOWLEDGE_SUFFIX" | translate }}
                </label>
              </div>
              @if (
                form.get("termsAccepted")?.touched &&
                form.get("termsAccepted")?.hasError("required")
              ) {
                <div class="fields-error-container mt-2">
                  {{ "REGISTER.TERMS_ACCEPTANCE_REQUIRED" | translate }}
                </div>
              }
            </div>

            @if (registerError) {
              <div class="field-control mb-4">
                <app-validation-message
                  [content]="{
                    title: 'REGISTER.ERROR_TITLE' | translate,
                    message: registerError,
                  }"
                  type="error"
                />
              </div>
            }

            <div class="field-control">
              <div class="flex flex-col gap-4 w-full sm:w-1/2">
                <app-button
                  class="block w-full sm:w-auto"
                  type="submit"
                  classesName="btn-primary-big w-full sm:w-auto"
                  [label]="'BUTTONS.SUBMIT' | translate"
                  [disabled]="isRegistrationFlowInProgress"
                ></app-button>
                @if (!isRegistrationFlowInProgress) {
                  <app-button
                    class="block w-full sm:w-auto"
                    type="button"
                    classesName="card-edge-cut-white btn-primary-big w-full sm:w-auto"
                    [label]="'BUTTONS.CANCEL' | translate"
                    (onBtnClick)="remindLater()"
                  ></app-button>
                }
              </div>
            </div>
          }
        </form>
      </div>
    </div>

    <app-service-progress
      [serviceName]="'REGISTER.TITLE' | translate"
      [showProgress]="true"
      [completePercentage]="completionPercent"
      [showChatWithUs]="true"
    />

    <!-- <div class="mt-8 px-12 flex flex-wrap items-center gap-4">
      <div class="flex flex-col gap-1 text-dc-navy">
        <span class="font-semibold">{{ "REGISTER.TITLE" | translate }}</span>
        <span class="text-sm text-dc-navy">{{
          "COMPLETE" | translate: { percent: completionPercent }
        }}</span>
      </div>
      <div
        class="w-full max-w-[200px] h-2 bg-gray-200 rounded-full overflow-hidden"
      >
        <span
          class="block h-full bg-[#1D4FA3]"
          [style.width.%]="completionPercent"
        ></span>
      </div>
      @if (flags.chatEnabled) {
        <a
          class="flex items-center gap-2 mb-4"
          [attr.data-label]="'CHAT_WITH_US' | translate"
        >
          <img [src]="getIconPath('svg/comment.svg')" />
          <span class="label">{{ "CHAT_WITH_US" | translate }}</span>
        </a>
      }
    </div> -->
  </div>
</div>

@if (verifyEmailModal) {
  <app-verify-email
    [LoginName]="userLoginName"
    [EmailAddr]="userEmail"
    (verified)="onVerifyEmailSuccess()"
    (closed)="onVerifyEmailClosed()"
  ></app-verify-email>
}

@if (showMembershipDisclaimerModal) {
  <app-membership-disclaimer
    (onSubmit)="onMembershipDisclaimerSubmit($event)"
  ></app-membership-disclaimer>
}
